"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationTable = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _input = require("@creditas/input");

var _Pagination = require("./Pagination");

var _PaginationTable = require("./PaginationTable.styled");

var _core = require("@emotion/core");

const PaginationTable = ({
  ariaTranslations,
  current,
  disabled,
  maxPages,
  onChangePage,
  onChangePageSize,
  pageSize,
  pageSizeOptions,
  total,
  translations,
  ...others
}) => {
  return (0, _core.jsx)(_PaginationTable.StyledPagination, others, (0, _core.jsx)(_PaginationTable.Group, null, translations.overview(current, total)), (0, _core.jsx)(_PaginationTable.Group, null, (0, _core.jsx)(_Pagination.Pagination, {
    current: current,
    disabled: disabled,
    maxPages: maxPages,
    onChange: onChangePage,
    total: total,
    ariaTranslations: ariaTranslations
  })), (0, _core.jsx)(_PaginationTable.Group, null, (0, _core.jsx)(_input.Select, {
    "data-testid": "select",
    value: pageSize,
    onChange: event => {
      onChangePageSize(Number(event.target.value));
    },
    style: {
      fontSize: 16,
      borderBottom: 0
    }
  }, pageSizeOptions.map(size => (0, _core.jsx)("option", {
    key: size,
    value: size
  }, translations.select(size))))));
};

exports.PaginationTable = PaginationTable;
PaginationTable.defaultProps = {
  ariaTranslations: {
    currentPage: current => `current page ${current}`,
    firstPage: () => 'first page',
    lastPage: () => 'last page',
    nextPage: () => 'next page',
    page: page => `page ${page}`,
    previousPage: () => 'previous page'
  },
  current: 1,
  disabled: false,
  maxPages: 5,
  pageSize: 10,
  pageSizeOptions: [10, 20, 30, 40],
  total: 1,
  translations: {
    overview: (current, total) => `${current} of ${total}`,
    select: option => `Show ${option}`
  }
};
process.env.NODE_ENV !== "production" ? PaginationTable.propTypes = {
  ariaTranslations: (0, _propTypes.shape)({
    currentPage: _propTypes.func,
    firstPage: _propTypes.func,
    lastPage: _propTypes.func,
    nextPage: _propTypes.func,
    page: _propTypes.func,
    previousPage: _propTypes.func
  }),
  current: _propTypes.number,
  disabled: _propTypes.bool,
  maxPages: _propTypes.number,
  onChangePage: _propTypes.func,
  onChangePageSize: _propTypes.func,
  pageSize: _propTypes.number,
  pageSizeOptions: (0, _propTypes.arrayOf)(_propTypes.number),
  total: _propTypes.number,
  translations: (0, _propTypes.shape)({
    overview: _propTypes.func,
    select: _propTypes.func
  })
} : void 0;